export class SumasySaldosGroupAccountsModel {
  group: string;
  checked: boolean;
}

export class SumasySaldosGroupModel {
  groups: SumasySaldosGroupAccountsModel[];
  from: number;
  to: number;
  levelAccounts: string;
  global: boolean;
}

export class SumasySaldosView {
  accountId: number;
  accountNumber: string;
  title: string;
  debe: number;
  haber: number;
  saldoDeudor: number;
  saldoAcreedor: number;

  constructor() {
    this.debe = 0;
    this.haber = 0;
    this.saldoDeudor = 0;
    this.saldoAcreedor = 0;
  }
}